import { useEffect, useState } from 'react';
import validate from 'validate.js';

export const useValidationForm = ({
  schemaToValidate,
  afterValidateOnChangeFn,
  initValues = {}
}) => {
  const [formState, setFormState] = useState({
    isValid: false,
    values: initValues,
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schemaToValidate);
    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {}
    }));
  }, [formState.values, schemaToValidate]);

  const handleChange = (event) => {
    if (event.persist) {
      event.persist();
    }
    setFormState((formState) => {
      const updatedState = {
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]:
            event.target.type === 'checkbox'
              ? event.target.checked
              : event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        }
      };
      if (afterValidateOnChangeFn) {
        afterValidateOnChangeFn(updatedState.values);
      }
      return updatedState;
    });
  };
  const hasError = (field) =>
    !!(formState.touched[field] && formState.errors[field]);
  const handleChangeCustomFieldName = (value, fieldName) => {
    handleChange({
      target: {
        name: fieldName,
        value
      }
    });
  };
  const resetForm = () => {
    setFormState({
      isValid: false,
      values: initValues,
      touched: {},
      errors: {}
    });
  };
  return {
    handleChange,
    hasError,
    formState,
    isValidForm: Object.keys(formState.errors).length > 0,
    handleChangeCustomFieldName,
    resetForm
  };
};
